import { DateTime } from 'luxon'

// Время и короткие тексты экранов поддержки (handoff 02-screens p4-p6, f01-f24). now - для проверки.

const MONTHS_SHORT = ['янв', 'февр', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сент', 'окт', 'нояб', 'дек']
const RATING = ['плохо', 'так себе', 'нормально', 'хорошо', 'отлично']

function at (iso, now) {
  return DateTime.fromISO(iso).setZone(now.zone)
}

function daysFromToday (dt, now) {
  return dt.startOf('day').diff(now.startOf('day'), 'days').days
}

function shortDate (dt, now) {
  const base = `${dt.day} ${MONTHS_SHORT[dt.month - 1]}`

  return dt.year === now.year ? base : `${base} ${dt.year}`
}

export function clock (iso) {
  return DateTime.fromISO(iso).toFormat('HH:mm')
}

/** Строка карточки и панели: «сегодня, 10:12», «вчера, 14:09», «21 сент». */
export function rowTime (iso, now = DateTime.now()) {
  const dt = at(iso, now)
  const days = daysFromToday(dt, now)
  if (days === 0) return `сегодня, ${dt.toFormat('HH:mm')}`
  if (days === -1) return `вчера, ${dt.toFormat('HH:mm')}`

  return shortDate(dt, now)
}

/** Плитка «Открытые обращения филиала»: «сегодня», «вчера», «10 сент». */
export function shortDay (iso, now = DateTime.now()) {
  const dt = at(iso, now)
  const days = daysFromToday(dt, now)
  if (days === 0) return 'сегодня'
  if (days === -1) return 'вчера'

  return shortDate(dt, now)
}

/** Пилюля дня в ленте: «Сегодня», «Вчера, 22 сентября», «14 сентября». */
export function feedDay (iso, now = DateTime.now()) {
  const dt = at(iso, now).setLocale('ru')
  const days = daysFromToday(dt, now)
  if (days === 0) return 'Сегодня'
  const date = dt.year === now.year ? dt.toFormat('d MMMM') : dt.toFormat('d MMMM yyyy')
  if (days === -1) return `Вчера, ${date}`

  return date
}

/** Бейдж «Обращения филиала» в шторке: «1 новый», «2 новых», «21 новый». */
export function newCount (n) {
  const one = n % 10 === 1 && n % 100 !== 11

  return `${n} ${one ? 'новый' : 'новых'}`
}

/** Под звёздами: «4 из 5 · хорошо». */
export function ratingLine (score) {
  return `${score} из 5 · ${RATING[score - 1]}`
}

/** Часы поддержки для шторки: «10:00-22:00 МСК». */
export function scheduleText (schedule) {
  if (!schedule) return null
  const zone = schedule.tz === 'Europe/Moscow' ? 'МСК' : schedule.tz

  return `${schedule.from}-${schedule.to} ${zone}`
}

/** «967 ₽», «12 500 ₽» - пробел-разделитель тысяч, как на макетах формы. */
export function money (total) {
  return `${String(Math.round(total)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ₽`
}

/** Чип итогового экрана формы: «· 1 фото»; без фото - пусто. */
export function photos (n) {
  return n > 0 ? `${n} фото` : ''
}
